// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static-shoplazza-test/css/" + {"64":"TanchuangNew","178":"Tanchuang","403":"cartAnimateCss"}[chunkId] + "." + {"64":"de9fcb87","178":"de9fcb87","403":"02594a64"}[chunkId] + ".chunk.css";
};